import growz from '../../pages/growz';
import intro from '../../pages/intro';
import { redirectToGrowz } from '../../utils';
import * as permissions from '../permissions';

export default [
  { path: '/growz', component: redirectToGrowz },
  { path: '/growz/intro', component: intro.GrowzIntro },
  { path: '/growz/overview', component: growz.GrowzOverview },
  { path: '/growz/dashboard', component: growz.dashboard },
  { path: '/growz/analytics', component: growz.analytics, permission: permissions.PERM_GROWZ_ANALYTICS_VIEW },
  { path: '/growz/campaigns', component: growz.campaigns, permission: permissions.PERM_GROWZ_ALL_CAMPAIGNS_VIEW },
  { path: '/growz/campaigns/:type', component: growz.campaigns, permission: permissions.PERM_GROWZ_ALL_CAMPAIGNS_VIEW },
  { path: '/growz/campaigns/:id/view', component: growz.campaign, permission: permissions.PERM_GROWZ_ALL_CAMPAIGNS_VIEW },
  { path: '/growz/account-settings/profile', component: growz.profileSettings },
  { path: '/growz/account-settings/change-password', component: growz.changePassword },
  { path: '/growz/store-settings/profile', component: growz.storeProfile },
  { path: '/growz/account-settings/notification', component: growz.storeNotifications },
  { path: '/growz/store-settings/custom-name', component: growz.customName },
  { path: '/growz/store-settings/store-reconnect', component: growz.storeReconnect },
  {
    path: '/growz/campaigns/adgroup/:id/view',
    component: growz.adGroups,
    permission: permissions.PERM_GROWZ_ALL_CAMPAIGNS_VIEW,
  },
  {
    path: '/growz/campaigns/adgroup/:id/target/bidding',
    component: growz.adGroupTargetBiding,
    permission: permissions.PERM_GROWZ_ALL_CAMPAIGNS_VIEW,
  },
  {
    path: '/growz/campaigns/adgroup/:id/target/bidding/:strategy/details',
    component: growz.adGroupTargetBidingDetails,
    permission: permissions.PERM_GROWZ_ALL_CAMPAIGNS_VIEW,
  },
  {
    path: '/growz/campaigns/adgroup/:id/keyword/scout',
    component: growz.adGroupKeywordScout,
    permission: permissions.PERM_GROWZ_ALL_CAMPAIGNS_VIEW,
  },
  {
    path: '/growz/campaigns/adgroup/:id/keyword/scout/:scoutId/view',
    component: growz.adGroupKeywordScoutView,
    permission: permissions.PERM_GROWZ_ALL_CAMPAIGNS_VIEW,
  },
  {
    path: '/growz/campaigns/adgroup/:id/keywords/edit',
    component: growz.GrowzKeywordsEdit,
    permission: permissions.PERM_GROWZ_ALL_CAMPAIGNS_VIEW,
  },

  { path: '/growz/strategy', component: growz.microGoals, permission: permissions.PERM_GROWZ_MICROGOALS_VIEW },
  { path: '/growz/micro-goal/:goalSlug', component: growz.microGoal },
  { path: '/growz/strategy/launched', component: growz.microGoalsLaunched },
  { path: '/growz/strategy-recommended/:type', component: growz.recommendedGoals },
  { path: '/growz/strategy/:goalSlug/launch', component: growz.goalLaunch },

  // Routes for strategies
  { path: '/growz/strategy/:goalSlug', component: growz.strategy },
  { path: '/growz/strategy/asin/:asin', component: growz.strategy },

  // Routes for SB Creatives.
  // { path: '/growz/sb/creatives', component: growz.GrowzSBCreatives },
  { path: '/growz/sb/assets', component: growz.GrowzSBAssets },
  { path: '/growz/sb/assets/add', component: growz.GrowzSBAssetsAdd },
  { path: '/growz/creatives/', component: growz.GrowzCreatives },

  // Routes for MicroGoal Activity
  { path: '/growz/strategy/:sellerMicroGoalId/activity/', component: growz.growzMicroGoalActivityV2 },
  { path: '/growz/strategy/:sellerMicroGoalId/activity/edit/', component: growz.growzMicroGoalActivityEdit },
  {
    path: '/growz/strategy/:sellerMicroGoalId/activity/target/report',
    component: growz.growzMicroGoalReportsTarget,
  },
  {
    path: '/growz/strategy/:sellerMicroGoalId/activity/product/report',
    component: growz.growzMicroGoalReportsProducts,
  },
  {
    path: '/growz/strategy/:sellerMicroGoalId/activity/campaign/report',
    component: growz.growzMicroGoalReportsCampagins,
  },
  {
    path: '/growz/strategy/:sellerMicroGoalId/activity/projections',
    component: growz.growzMicroGoalActivityProjections,
  },

  // Audit page components
  { path: '/growz/audit', component: growz.GrowzAuditIndex },

  // keywords research
  {
    path: '/growz/keyword/',
    component: growz.GrowzKeywordResearch,
    permission: permissions.PERM_GROWZ_KEYWORD_TOOL_ACCESS,
  },
  {
    path: '/growz/keyword/reverse-asin',
    component: growz.GrowzKeywordResearch,
    permission: permissions.PERM_GROWZ_KEYWORD_TOOL_ACCESS,
  },

  // rank tracker
  {
    path: '/growz/rank-tracker',
    component: growz.GrowzRankTracker,
  },
  {
    path: '/growz/rank-tracker/:id',
    component: growz.GrowzRankTrackerDashboard,
  },

  // Creative page
  { path: '/growz/creatives/dashboard', component: growz.GrowzCreativesDashboard },
  { path: '/growz/creative', component: growz.GrowzCreative },
  { path: '/growz/creative/sb/', component: growz.GrowzCreativeSB },
  { path: '/growz/creative/sd', component: growz.GrowzCreativeSD },

  // recommendation
  { path: '/growz/recommendation', component: growz.GrowzAnalyze, permission: permissions.PERM_GROWZ_ANALYZE_SCREEN_ACCESS },

  // product pulse
  { path: '/growz/products', component: growz.GrowzProducts, permission: permissions.PERM_GROWZ_PRODUCT_VIEW },
  { path: '/growz/products/:id', component: growz.GrowzProduct, permission: permissions.PERM_GROWZ_PRODUCT_VIEW },

  // for internal use only
  { path: '/growz/asin/ads/structure', component: growz.GrowzProductStructure },

  // reports
  { path: '/growz/reports/dashboard', component: growz.reports, permission: permissions.PERM_GROWZ_ANALYTICS_VIEW },
  {
    path: '/growz/reports/comparison',
    component: growz.reportsComparison,
    permission: permissions.PERM_GROWZ_ANALYTICS_VIEW,
  },
  {
    path: '/growz/reports/placement-reports',
    component: growz.reportsPlacement,
    permission: permissions.PERM_GROWZ_ANALYTICS_VIEW,
  },
  {
    path: '/growz/reports/store-keyword',
    component: growz.StoreKeywordReport,
    permission: permissions.PERM_GROWZ_ANALYTICS_VIEW,
  },
  {
    path: '/growz/reports/store-targets',
    component: growz.StoreTargetsReport,
    permission: permissions.PERM_GROWZ_ANALYTICS_VIEW,
  },
  {
    path: '/growz/reports/store-search-term',
    component: growz.StoreSearchTermReport,
    permission: permissions.PERM_GROWZ_ANALYTICS_VIEW,
  },
  {
    path: '/growz/reports/store-product-ads',
    component: growz.StoreProductReport,
    permission: permissions.PERM_GROWZ_ANALYTICS_VIEW,
  },
  {
    path: '/growz/reports/store-product-asin',
    component: growz.StoreProductReport,
    permission: permissions.PERM_GROWZ_ANALYTICS_VIEW,
  },
  {
    path: '/growz/reports/store-campaign',
    component: growz.StoreCampaignReport,
    permission: permissions.PERM_GROWZ_ANALYTICS_VIEW,
  },
  {
    path: '/growz/reports/store-placement',
    component: growz.StorePlacementReport,
    permission: permissions.PERM_GROWZ_ANALYTICS_VIEW,
  },
  {
    path: '/growz/reports/brand-metrics',
    component: growz.StoreBrandMetrics,
    permission: permissions.PERM_GROWZ_ANALYTICS_VIEW,
  },
  {
    path: '/growz/reports/brand-metrics-category-report',
    component: growz.StoreBrandMetricsCategoryReport,
    permission: permissions.PERM_GROWZ_ANALYTICS_VIEW,
  },
  {
    path: '/growz/reports/asin-keywords-target-report',
    component: growz.StoreKeywordsTargetsByAsinReport,
    permission: permissions.PERM_GROWZ_ANALYTICS_VIEW,
  },

  // subscription
  {
    path: '/:realm/subscription/active-plan',
    component: growz.GrowzActivePlan,
  },
  {
    path: '/:realm/subscription/add-ons',
    component: growz.GrowzSubscriptionAdOns,
  },
  {
    path: '/:realm/subscription/invoices',
    component: growz.GrowzSubscriptionInvoices,
  },
  {
    path: '/:realm/subscription/checkout/add-ons',
    component: growz.addOns,
  },
  {
    path: '/:realm/subscription/plans',
    component: growz.payments,
  },
  {
    path: '/:realm/subscription/usage',
    component: growz.usages,
  },
  {
    path: '/growz/asin/sp/structure',
    component: growz.AsinSPStructure,
  },
  {
    path: '/growz/reports/search-term-report',
    component: growz.AsinSearchTerms,
  },
  {
    path: '/growz/asin/sp/:asin/fix/details',
    component: growz.AsinSPStructureFixDetails,
  },
  {
    path: '/growz/asin/sd/:asin/fix/details',
    component: growz.AsinSDStructureFixDetails,
  },
  {
    path: '/growz/asin/sb/:asin/fix/details',
    component: growz.AsinSBStructureFixDetails,
  },
  {
    path: '/growz/asin/sd/structure',
    component: growz.AsinSDStructure,
  },
  {
    path: '/growz/asin/sb/structure',
    component: growz.AsinSBStructure,
  },
  {
    path: '/growz/add/keywords',
    component: growz.AddTargetsToAdGroup,
  },
  {
    path: '/growz/account-health',
    component: growz.AccountHealthPage,
  },

  {
    path: '/growz/account-health/account-level',
    component: growz.AccountHealthPage,
  },

  {
    path: '/growz/account-health/product-level',
    component: growz.AccountHealthPage,
  },
  {
    path: '/growz/campaign-launcher',
    component: growz.GrowzCampaignLauncher,
  },
  {
    path: '/growz/campaign-launcher/list',
    component: growz.GrowzSBCampaignLauncherList,
  },
  {
    path: '/growz/campaign-launcher/sp',
    component: growz.GrowzSPCampaignLauncher,
  },
  {
    path: '/growz/campaign-launcher/sd',
    component: growz.GrowzSDCampaignLauncher,
  },
  {
    path: '/growz/campaign-launcher/sb',
    component: growz.GrowzSBCampaignLauncher,
  },
  {
    path: '/growz/audit-reports',
    component: growz.GrowzAuditReports,
  },
];
